export const LANGUAGE_STORAGE_KEY = 'finance-lab.language'

export type SupportedLanguage = 'sv' | 'en'

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['sv', 'en']

export const DEFAULT_LANGUAGE: SupportedLanguage = 'sv'

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
    return value === 'sv' || value === 'en'
}

export function getStoredLanguage(): SupportedLanguage | null {
    try {
        const value = localStorage.getItem(LANGUAGE_STORAGE_KEY)
        return isSupportedLanguage(value) ? value : null
    } catch {
        return null
    }
}

export function setStoredLanguage(language: SupportedLanguage): void {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
}

export function resolveLanguage(language: string | null | undefined): SupportedLanguage {
    if (isSupportedLanguage(language)) {
        return language
    }

    if (language?.startsWith('sv')) {
        return 'sv'
    }

    if (language?.startsWith('en')) {
        return 'en'
    }

    return DEFAULT_LANGUAGE
}

let skipNextUserSettingsSync = false

export function markUserLanguageChoice(): void {
    skipNextUserSettingsSync = true
}

export function consumeSkipNextUserSettingsSync(): boolean {
    const shouldSkip = skipNextUserSettingsSync
    skipNextUserSettingsSync = false
    return shouldSkip
}
